var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('help-content',{attrs:{"title":'歩数イベントにおける異常データの回避方法'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_vm._v("\n          イベントを作成する時に、"),_c('b',[_vm._v("一日あたりの上限歩数")]),_vm._v("を設定できます。上限を超える歩数はイベントのスコアにカウントされません。合理的な上限値を設定することによって、異常（不正）データを回避することができます。\n        ")])])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72c6a43f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HelpAdmin3.vue
// module id = HIyz
// module chunks = 0